let appFnInitialized = false;

export default () => {
  if ("undefined" === typeof window || !appFnInitialized) {
    return appFnInitialized = true;
  }

  document
    .querySelectorAll("header.header .navigation__menu--sub .navigation__menu-item.navigation__menu-item--active")
    .forEach(element => {
      element.classList.remove("navigation__menu-item--active");
    });

  let currentPath = window.location.pathname;
  if (!currentPath.startsWith('/')) {
    currentPath = `/${currentPath}`;
  }
  if (!currentPath.endsWith('/')) {
    currentPath = `${currentPath}/`;
  }
  const urls = [`${window.location.pathname}${window.location.search}`];
  let chunks = currentPath.split('/');
  chunks.shift()
  chunks.pop()
  while (chunks.length) {
    urls.push('/' + chunks.join('/') + '/');
    chunks.pop();
  }

  urls.forEach(url => {
    document
      .querySelectorAll(`header.header .navigation__menu--sub .navigation__menu-item a[href="${url}"]`)
      .forEach(element => {
        element.parentElement.classList.add("navigation__menu-item--active");
      });
  });
};
